document.addEventListener('DOMContentLoaded', function(){


if(window.innerWidth <= 768){


const product = document.querySelector('.cc-main-product.product-main');

const media = document.querySelector('.product-media');

const info = document.querySelector('.product-info');


if(!product || !media || !info) return;


// 只针对指定产品
const allowedProducts = [

    'audreamy-bamboo-core-sheet-set',
    'audreamy-bamboo-fitted-sheet-set-no-flat-sheet',
    'audreamy-400tc-bamboo-cotton-quilt-cover-set',
    'audreamy-microfibre-core-sheet-set',
    'audreamy-microfibre-fitted-sheet-set-no-flat-sheet',
    'audreamy-1000tc-microfibre-duvet-quilt-cover-set',
    'audreamy-cotton-core-sheet-set',
    'audreamy-french-flax-linen-quilt-cover-set',
    'audreamy-100-mulberry-silk-pillowcase',
    'audreamy-400tc-bamboo-cotton-pillow-cases',
    'audreamy-bamboo-cotton-twin-pack-pillowcases',
    'audreamy-100-mulberry-silk-pillowcase',
    'audreamy-mulberry-silk-pillowcase',
    'audreamy-100-cotton-pillowcases-2-pack',
    'audreamy-1000tc-microfiber-pillowcase-pair',
    'audreamy-nuvia-kids-bamboo-waterproof-mattress-protector',
    'audreamy-silky-satin-sleep-gift-set',
   
];


if(
    !allowedProducts.some(handle =>
        window.location.pathname.includes(handle)
    )
){
    return;
}

// 找评分
// const rating = info.querySelector('.ap-rating-and-features');
//const rating = info.querySelector('.jdgm-preview-badge');
const rating =
    info.querySelector('.ap-rating-and-features') ||
    info.querySelector('.jdgm-preview-badge');


// 找icon区域
const blocks = info.querySelectorAll('.product-info__block');

const iconBlock = blocks[4];


// 图片移动到评分后面
if(rating){

    const ratingBlock = rating.closest('.product-info__block');

    if(ratingBlock){

        ratingBlock.after(media);

    }

}


// icon移动到图片后面
if(iconBlock){

    media.after(iconBlock);

}


}


});